import React from "react";

// Subtle golden cross watermark used across dark sections
export const GoldCross = ({ className = "", opacity = 0.07 }) => (
  <svg
    viewBox="0 0 100 140"
    className={className}
    aria-hidden="true"
    style={{ opacity }}
  >
    <defs>
      <linearGradient id="crossGold" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#E6C76A" />
        <stop offset="100%" stopColor="#C9A13A" />
      </linearGradient>
    </defs>
    <rect x="42" y="0" width="16" height="140" rx="3" fill="url(#crossGold)" />
    <rect x="14" y="34" width="72" height="16" rx="3" fill="url(#crossGold)" />
  </svg>
);

export default GoldCross;
